import React from 'react';
import {AuthContext} from '../main/provedorAutenticacao';
import ExportacaoService from '../app/service/exportacaoService';
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import moment from 'moment';

//import Dialog from 'react-dialog';

import { Dialog } from 'primereact/dialog';
import GerarAtaService from '../app/service/gerarAtaService';



class Home extends React.Component{
    state = {
        saldo: 0,
        ata: [],
        ataDetalhada:''
    }

    constructor(){
        super();
        this.state = {isDialogOpen: false};
        this.serviceExportacao = new ExportacaoService();
        this.serviceGerarAta = new GerarAtaService();
    }
    
   
    gerarAta = async () => {
        const dadosConsulta = {
             dataInicio: moment(this.state.dataInicio).format('DD/MM/yyyy'),
        }

        try{
            const response = await this.serviceGerarAta.gerarAtaPorData(dadosConsulta)
            this.setState({ata:response.data});
            const geraAta = response.data;
                    
            console.log("retorno service", response.data );
        //    console.log("retorno service2", this.state.ata.despachosDTO);

       }catch( erro){
            // mensagemErro(erro.response.data)
            console.log("retorno service erro");
          
        }finally{
           /*  this.setState({loading: false,
                disabled:false}) */
        }
    }

   
 
    cancelar = ()=> {
        this.setState({ isDialogOpen: false });
    }

    limpar = ()=> {
        this.serviceExportacao.limparDiretorioExportacao();
        this.setState({ isDialogOpen: false });
    }

    openDialog = () => this.setState({ isDialogOpen: true })
    handleClose = () => this.setState({ isDialogOpen: false })


    render(){
        const footer = (
            <div>
                <button type="button" className="btn btn-success" onClick={this.limpar} >
                <i className="pi pi-times"> </i> Confirma
                </button>
                <button label="No" icon="pi pi-times" onClick={this.cancelar} />
            </div>
        );
        
        const myIcon = (
            <button className="p-dialog-titlebar-icon p-link">
                <span className="pi pi-search"></span>
            </button>
        )
        return(
            <div className="jumbotron p-4 shadow bg-[rgba(64,73,62,0.8667)] rounded" >
                <h1 className="display-3 text-center italic tracking-tighter font-extrabold subtitulo-home text-[rgba(140,184,98,0.8667)]">JUCESC</h1>
                <p className="lead mb-0 text-center text-[rgba(140,184,98,0.8667)]">Junta Comercial do Estado de Santa Catarina.</p>
                <p className="lead text-center text-[rgba(168,181,166,1)]">Sistema de extração de dados de empresas.</p>
                <hr className="my-4 text-[rgba(168,181,166,1)]" />
                <p className="text-[rgba(168,181,166,1)]">Essa é a área administrativa, utilize um dos menus ou botões abaixo para navegar pelo sistema.</p>
                <p className="mb-0 mt-5">
               {/*      <a className="btn btn-primary btn-lg" 
                        href="#/cadastro-usuarios" 
                        role="button"><i className="fa fa-users"></i>
                         Cadastrar Usuário</a> */}
                   
                   <div className="container-btn-home"> 
                    <a className="btn btn-success btn-lg" 
                        href="#/exportacao-dados" role="button"><i className="fa fa-users"></i>  Exportação de dados</a>

                     <button onClick={this.openDialog} type="button" className="btn btn-danger  btn-lg">
                                <i className="pi pi-trash" style={{ fontWeight: "bolder"}}> </i> Limpar diretorio exportação
                      </button>
                    </div>
                    <br/>
          {/*           <div>
                      <a className="btn btn-warning btn-lg" 
                        href="#/geracao-ata" role="button"><i className="fa fa-users"></i>  Geração de Ata</a>
                    </div> */}
                </p>
                <Modal show={this.state.isDialogOpen} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                    {/* <Modal.Title>Modal heading</Modal.Title> */}
                    </Modal.Header>
                    <Modal.Body>Deseja excluir todas as exportações realizadas!</Modal.Body>
                    <Modal.Footer>
                    
                    <Button variant="primary"  className="btn btn-success" onClick={this.limpar}>
                        Sim
                    </Button>
                    <Button variant="secondary" className="btn btn-danger"  onClick={this.cancelar}>
                        Não
                    </Button>
                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}

Home.contextType = AuthContext;

export default Home;